<template>
  <SACModal
    :modalClass="`integrations-modal-${view} integrations-modal`"
    :cardClass="`int-${view}`"
    :show="show"
    :close="() => toggle(false)"
  >
    <template
      v-if="view === 'slack-connect'"
      #content
    >
      <SlackConnectPopup
        :update="update"
        :toggle="toggle"
      />
    </template>
    <template
      v-else-if="view === 'titan-connect'"
      #content
    >
      <TitanConnectPopup
        :update="update"
        :toggle="toggle"
      />
    </template>
    <template
      v-else-if="view === 'titan-edit-integration'"
      #content
    >
      <IntegrationsEditTitanPopup
        :update="update"
        :toggle="toggle"
      />
    </template>
    <template
      v-else-if="view === 'titan-map-membership'"
      #content
    >
      <MapMembershipTypesTitanPopup
        :update="update"
        :toggle="toggle"
      />
    </template>
    <template
      v-else-if="view === 'titan-map-jobs'"
      #content
    >
      <MapJobTypesTitanPopup
        :update="update"
        :toggle="toggle"
      />
    </template>
    <template
      v-else-if="view === 'sso-connect'"
      #content
    >
      <SSOConnectPopup
        :update="update"
        :iprovider="iprovider"
        :toggle="toggle"
      />
    </template>
    <template
      v-else-if="view === 'edit-slack-integration'"
      #content
    >
      <EditIntegrationPopup
        :partnerSettings="partnerSettings"
        :update="update"
        :toggle="toggle"
        :changeStateValue="changeStateValue"
      />
    </template>
    <template
      v-else-if="view === 'titan-map-cc'"
      #content
    >
      <MapCCServiceTitanPopup
        :update="update"
        :toggle="toggle"
      />
    </template>
    <template
      v-else-if="view === 'titan-map-tuneup'"
      #content
    >
      <MapTuneupJobTypesPopup
        :update="update"
        :toggle="toggle"
      />
    </template>
    <template
      v-else-if="view === 'titan-cred'"
      #content
    >
      <ClientSecretInput
        :partnerSettings="partnerSettings"
        :update="update"
        :toggle="toggle"
      />
    </template>
    <template
      v-else-if="view === 'disconnect-confirm'"
      #content
    >
      <DisconnectConfirm
        :partnerSettings="partnerSettings"
        :update="update"
        :toggle="toggle"
        :changeStateValue="changeStateValue"
      />
    </template>
    <template
      v-else-if="view === 'titan-installation-guide'"
      #content
    >
      <ServiceTitanSetUp
        :toggle="toggle"
        :update="update"
      />
    </template>
  </SACModal>
</template>

<script>
import SACModal from '@shared/components/sac/SACModal.vue';
import SlackConnectPopup
  from '@shared/components/setting/integrationsInfo/modals/SlackConnectPopup.vue';
import TitanConnectPopup
  from '@shared/components/setting/integrationsInfo/modals/TitanConnectPopup.vue';
import { mapState } from 'vuex';
import SSOConnectPopup from './SSOConnectPopup.vue';
import IntegrationsEditTitanPopup from './IntegrationsEditTitanPopup.vue';
import MapMembershipTypesTitanPopup from './MapMembershipTypesTitanPopup.vue';
import MapJobTypesTitanPopup from './MapJobTypesTitanPopup.vue';
import EditIntegrationPopup from './EditIntegrationPopup.vue';
import MapCCServiceTitanPopup from './MapCCServiceTitanPopup.vue';
import ClientSecretInput from './ClientSecretInput.vue';
import DisconnectConfirm from './DisconnectConfirm.vue';
import ServiceTitanSetUp from './ServiceTitanSetUp.vue';
import MapTuneupJobTypesPopup from './MapTuneupJobTypesPopup.vue';

export default {
  name: 'IntegrationsModal',
  components: {
    MapTuneupJobTypesPopup,
    TitanConnectPopup,
    SlackConnectPopup,
    SACModal,
    IntegrationsEditTitanPopup,
    MapMembershipTypesTitanPopup,
    MapJobTypesTitanPopup,
    MapCCServiceTitanPopup,
    EditIntegrationPopup,
    DisconnectConfirm,
    SSOConnectPopup,
    ServiceTitanSetUp,
    ClientSecretInput,
  },
  props: {
    toggle: Function,
    update: Function,
    iprovider: Object,
    partnerSettings: Object,
    changeStateValue: Function,
  },
  computed: {
    ...mapState({
      show: (state) => state.setting.showIntActionModal,
      view: (state) => state.setting.actionIntModalView,
    }),
  },
};
</script>

<style lang="scss">
.integrations-modal{
  .int-connect-address {
    width: 856px;
    height: 700px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .int-titan-map-jobs,
  .int-slack-connect,
  .int-sso-connect,
  .int-titan-map-membership {
    width: 950px;
    height: calc(100vh - 140px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .int-titan-map-cc {
    width: 950px;
    height: 500px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .int-titan-map-tuneup {
    width: 950px;
    height: 500px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .int-titan-connect {
    width: 900px;
    height: 700px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .int-titan-edit-integration {
    width: 1000px;
    height: calc(100vh - 140px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .int-sso-connect {
    width: 950px;
    height: calc(100vh - 140px);

  }
  .int-edit-slack-integration {
    width: 900px;
    height: calc(100vh - 200px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .int-titan-cred {
    width: 900px;
    height: 700px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .int-titan-installation-guide {
    max-width: 1000px;
    width: calc(100vw - 400px);
    height: 700px;
    .ac-body-container {
      overflow-y: auto;
    }
    .ac-footer-container {
      justify-content: start;
    }
  }
  .int-disconnect-confirm {
    width: 640px;
    height: 320px;
  }
  .ac-input-container {
    margin-right: 0;
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;
    justify-content: space-between;
    .ac-header-container {
      padding: 24px 24px 12px 24px;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 16px;
      border-bottom: 1px solid $NBLUE10;
      .ac-header {
        font-size: 1.5rem;
        font-weight: 600;
        text-transform: capitalize;
      }
    }
    .ac-body-container {
      flex: 1;
      gap: 16PX;
      padding: 8px 24px;
      .ac-body-header {
        flex: 1;
        font-size: 1.25rem;
        font-weight: 500;
        text-align: center;
        margin-bottom: 24px;
      }
      .ac-input-container {
        &:not(:last-child) {
          margin-bottom: 18px;
        }
        .ac-input-header {
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: 4px;
          .ac-input-sub {
            font-size: 0.75rem;
            color: $N50;
          }
          .ac-input-text {
            font-size: 0.85rem;
            color: $N70;
          }
        }
      }
    }
    .ac-footer-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid $N10;
      padding: 16px 24px;
    }
    .ac-overlay {
      border-radius: 12px;
    }
  }
}
</style>
